import { render, staticRenderFns } from "./ParentsHome.vue?vue&type=template&id=3bbaf490&scoped=true&"
import script from "./ParentsHome.vue?vue&type=script&lang=js&"
export * from "./ParentsHome.vue?vue&type=script&lang=js&"
import style0 from "./ParentsHome.vue?vue&type=style&index=0&id=3bbaf490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbaf490",
  null
  
)

export default component.exports